// extracted by mini-css-extract-plugin
export default {"container":"RentalPage_container__HLZLn","wrapper":"RentalPage_wrapper__tAOn-","content":"RentalPage_content__joO9z"};